export default "/images/vendor/flag-icon-css/flags/1x1/es-ga.svg?33cb6bd3598af69a5a6d38e7264f977e";